import { render, staticRenderFns } from "./FooterPj.vue?vue&type=template&id=5105c0e2&scoped=true"
import script from "./FooterPj.vue?vue&type=script&lang=js"
export * from "./FooterPj.vue?vue&type=script&lang=js"
import style0 from "./FooterPj.vue?vue&type=style&index=0&id=5105c0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5105c0e2",
  null
  
)

export default component.exports